import { Injectable } from "@angular/core";
import { WindowReferenceService } from "./window-reference.service";
import { AppStateService } from "./app-state.service";

@Injectable({
  providedIn: "root",
})
export class DataLayerService {
  private window;
  private appState: AppStateService; // App-wide state dependency

  constructor(private _windowRef: WindowReferenceService, appState: AppStateService) {
    this.window = _windowRef.nativeWindow; // intialise the window to what we get from our window service
    this.appState = appState;
  }

  private addToDataLayer(obj) {

    if (obj) this.window.dataLayer.push(obj);
  }
  setSelectedDeviceInfo(dataObj) {
    this.addToDataLayer(dataObj);
  }
  resetRegion(filter) {
    const index = this.window.dataLayer.findIndex(
      (item) => item.region === filter
    );
    this.window.dataLayer.splice(index, 1);
  }
  resetcollapsedFeatures(filter) {
    const index = this.window.dataLayer.findIndex((item) => {
      if(item.event != "collapseFeature"){
        return;
      }
      if (
        item.event === "collapseFeature" &&
        item.features[0].name === filter
      ) {
        return item;
      }
    });
    this.window.dataLayer.splice(index, 1);
  }
  resetSearch() {
    const index = this.window.dataLayer.findIndex((x) => x.event === "search");
    this.window.dataLayer.splice(index, 1);
  }
  resetSetSelectedDeviceInfo() {
    const data = this.appState.getReaderDeviceFullInfo();
    if (data && data.length > 0) {
      const index = this.window.dataLayer.findIndex(
        (x) => x.productName === data[0].deviceName
      );
      this.window.dataLayer.splice(index, 1);
    }
  }
  logUserDetails(userDataObj) {
    this.addToDataLayer(userDataObj);
  }
  checkAndAdd(data) {
    const matchedData = this.window.dataLayer.find(
      (item) => item.region === data.region
    );
    if (!matchedData) {
      this.addToDataLayer(data);
    }
  }
  logSearchEvent(eventObj) {
    this.addToDataLayer(eventObj);
  }
}

